import styled from "styled-components";
export const TitleCurrentCity = styled.span `
  color: #9D87F1;
`;
export const Description = styled.span `
  font-size: 0.75rem;
  font-style: normal;
  font-weight: 400;
  line-height: 150%;
  color: #9F9F9F;
`;
